import styled, { keyframes } from 'styled-components';
import { rem } from '../../utils';
import { Placeholder, Spacing } from '../../theme';
export const placeholderSize = {
    Small: {
        width: '100%',
        height: rem(Placeholder.Size.Small),
        gap: rem(Spacing.Size.XXSmall),
    },
    Medium: {
        width: '100%',
        height: rem(Placeholder.Size.Medium),
        gap: rem(Spacing.Size.Medium),
    },
};
export const placeholderShimmerKeyframe = keyframes `
  0% {
    background-position: ${rem(-1000)} 0;
  }
  100% {
    background-position: ${rem(1000)} 0;
  }
`;
export const StyledWrapper = styled.div `
  display: flex;
  flex-flow: column;
  width: 100%;
  gap: ${({ size }) => { var _a, _b; return (_b = (_a = placeholderSize[size]) === null || _a === void 0 ? void 0 : _a.gap) !== null && _b !== void 0 ? _b : placeholderSize.Medium.gap; }};
`;
export const StyledPlaceholder = styled.div `
  width: ${placeholderSize.Medium.width};

  height: ${({ size }) => { var _a, _b; return (_b = (_a = placeholderSize[size]) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : placeholderSize.Medium; }};

  background: ${({ theme }) => `linear-gradient(
      to right,
     ${theme.Color.Neutrals.Light} 5%,
     rgba(0, 0, 0, 0.06) 35%,
     ${theme.Color.Neutrals.Light} 65%
    )`};
  border-radius: ${({ theme }) => theme.Border.Radius.Medium}px;
  animation: ${placeholderShimmerKeyframe} 1.4s linear 0s infinite normal
    forwards;
  background-size: ${rem(1000)} 100%;
`;
//# sourceMappingURL=Placeholder.style.js.map